import { Box } from '@mui/material'
import { SxProps } from '@mui/system'
import { Children, FC, PropsWithChildren, ReactNode } from 'react'

type StepsProps = {
  value: number
  children: ReactNode[]
  sx?: SxProps
}

export const Steps: FC<StepsProps> = ({ value, children, sx = {} }) => (
  <Box sx={sx}>
    {Children.map(children, (child, index) => (
      <Step index={index} value={value} key={index} sx={sx}>
        {child}
      </Step>
    ))}
  </Box>
)

type StepProps = PropsWithChildren<{
  value: number
  index: number
  sx: SxProps
}>
const Step: FC<StepProps> = ({ index, value, sx, children }) => (
  <Box hidden={value !== index} sx={sx}>
    {value === index && children}
  </Box>
)
